module.exports = __webpack_public_path__ + "img/id_card_bg.15365075.jpg";